export interface IActionTypes {
    LOGIN: string,
    LOGOUT: string,
    ALL_JOBS: string,
}

export const ActionTypes: IActionTypes = {
    LOGIN: "LOGIN",
    LOGOUT: "LOGOUT",
    ALL_JOBS: "ALL_JOBS",
}